import {
  LICENSE_PLAN_STATUS,
  type LicensePlanStatus,
} from "@/v2-backoffice-client/license/plan/license.plan.constants"
import type { LicensePlanFragment } from "@/v2-backoffice-client/license/plan/__types__/license.plan.fragment"

type LicensePlanStatusFacts = Pick<
  LicensePlanFragment,
  "ProductCode" | "DeprecatedAt"
>

/**
 * One definition of a license's status, shared by the board's Status column
 * and pills and the license panel, so they can never disagree.
 *
 * Needs setup means no product yet: the Fenerum import skips a license's
 * subscriptions until an operator says which product it is for
 * (api.Sync_Lic_FenerumLicenses derives nothing from a plan without a
 * ProductCode), so no customer is put on it and the board shows no customers
 * and no MRR for it. Seat semantics are not part of the status: without them
 * the license still derives, its customers just get no seat count, and the
 * Seat Semantics cell says so in red. Deprecated wins: a license being
 * retired is not one to set up.
 */
export function getLicensePlanStatus(
  plan: LicensePlanStatusFacts,
): LicensePlanStatus {
  if (plan.DeprecatedAt) return LICENSE_PLAN_STATUS.Deprecated
  if (plan.ProductCode === null || plan.ProductCode === undefined) {
    return LICENSE_PLAN_STATUS.NeedsSetup
  }
  return LICENSE_PLAN_STATUS.Live
}
